import i18n from "../../i18n/index";
import copaymentService from "../../services/copayment/CopaymentService.js";
import orderService from "../../services/orders/OrderService.js";
import dayjs from "dayjs";
import XLSX from 'xlsx';

export default {
  components: {
  },
  data: () => ({
    headers: [{
      id: 0,
      text: i18n.t('headers.load-date'),
      sortable: false,
      value: "shippingDate"
  },
  {
      id: 1,
      text: i18n.t('headers.user'),
      sortable: false,
      value: "number"
  },
  {
    id: 2,
    text: i18n.t('headers.patient-name'),
    sortable: false,
    value: "number"
},
  {
      id: 3,
      text: i18n.t('headers.total-orders'),
      sortable: false,
      value: "patient_document"
  },
  {
      id: 4,
      text: i18n.t('headers.total-errors'),
      sortable: false,
      value: "patient_name"
  },
  {
      id: 5,
      text: i18n.t('headers.errors-detail'),
      value: "status",
      sortable: false
  },
  
  ],
  logs: [],
  totallogs: 0,
  rowsPerPageItems: [5, 10],
  pagination: {},
  copayments: [],
  file: '',
  loaded: false,
  loading: false,
  templateLink: 'http://104.248.183.112:3001/template/copayment',
  loading: false,
  maxDatePreviewDelivery: '',
  newStatusSelect : null,
  disabled: false 
  }),
  computed: {
    customHeaders() {
        return this.headers
    }
},
  async created() {
    this.maxDatePreviewDelivery = dayjs(new Date()).format("YYYY-MM-DD")
  },

  watch: {
    pagination: {
      handler() {
        this.getLog();
      },
      deep: true
  }
  },

  methods: {

    showColumn(i) {
      return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
    },

    onChangeFileUpload() {
      if (this.$refs.file.files[0] !== undefined) {
        this.file = this.$refs.file.files[0]
        this.loaded = true
      } else {
        this.loaded = false
      }
    },
    downloadTemplate () {
      const columns = XLSX.utils.json_to_sheet([
        {pedido: 1 , estado: 'entregado'},
        {pedido: 2 , estado: 'cancelado', motivoCancelacion:'1'},
        {pedido: 3 , estado: 'devuelto'},
        {pedido: 4 , estado: 'cancelado', motivoCancelacion:'5'}
       ])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, columns, 'pedidos')
      XLSX.writeFile(wb, 'plantilla_cambio_masivo_estado_administrador.xlsx')
    },
    async readFile () {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function (e) {
            let data = e.target.result;
            data = new Uint8Array(data);
            let workbook = XLSX.read(data, {type: 'array'});
            let result = {};
            let i = 0;
            workbook.SheetNames.forEach(function (sheetName) {
                let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                if (roa.length) {
                  result[i] = roa;
                  i++;
                }
            });
            resolve(result);
        };
        reader.onerror = function(event) {
          reader.abort();
          reject(reader.error)
        };
        reader.readAsArrayBuffer(this.file);
      });
    },
    async submitForm() {
      try {
        if (this.file !== undefined && this.file !== '') {
          this.loading = true

          const dataFromExcel = await this.readFile();
          if (dataFromExcel[0].length === 0) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: 'El archivo no contiene información'
            })
            this.loading = false
            return
          }

          for (let i = 0; i < dataFromExcel[0].length; i++) {
            const row = dataFromExcel[0][i];
            if (!row.hasOwnProperty('pedido')) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene un número de pedido en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (!row.hasOwnProperty('estado')) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene el nuevo estado del pedido en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (!/^\d+$/.test(row.pedido)) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene un número de pedido válido en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
            if (row.estado !== 'entregado' && row.estado !== 'devuelto' && row.estado !== 'cancelado') {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no tiene un estado válido en la línea ${i + 2}`
              })
              this.loading = false
              return
            }
            console.log(row.estado == 'cancelado' && row.motivoCancelacion !== undefined && row.motivoCancelacion !== '')
            if (row.estado == 'cancelado' && !(row.motivoCancelacion > 0 && row.motivoCancelacion < 11)) {
              this.$notify({
                  group: 'app',
                  type: 'error',
                  text: `El archivo no tiene un motivo de cancelación válido en la línea ${i + 2}`
                })
                this.loading = false
                return
            }
          }
          const data = {
            data: dataFromExcel[0]
          }
          
          orderService.bulkUpdateAdmin(data).then(() => {
            console.log('La solicitud ha sido enviada.');
          }).catch(error => {
            console.error('Error al enviar la solicitud:', error);
          });
    
          this.$notify({
            group: 'app',
            type: 'success',
            text: 'La solicitud ya está siendo procesada, revise las órdenes más tarde'
          });
          this.clearFileInput();
          this.loading = false
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'No ha cargado el archivo de cambios de estado'
          })
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }
    },

    clearFileInput() {
      this.$refs.file.value = '';
      this.file = '';
      this.loaded = false;
    },

    getLog(){
      this.loading = true;
      this.orders = [];
      orderService.getLogBulkUpdateAdmin().then(
        data => {
          console.log(data)
          this.loading = false;
          this.logs = data.data;
          this.totalOrders = data.data.length;
      })
    },

    
     formatearFecha(fechaISO) {
      const fecha = new Date(fechaISO);
    
      const dia = String(fecha.getDate()).padStart(2, '0');
      const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Ojo: Enero es 0
      const anio = fecha.getFullYear();
    
      const horas = String(fecha.getHours()).padStart(2, '0');
      const minutos = String(fecha.getMinutes()).padStart(2, '0');
      const segundos = String(fecha.getSeconds()).padStart(2, '0');
    
      return `${dia}-${mes}-${anio} ${horas}:${minutos}:${segundos}`;
    },

    descargarCSV(errorDetail) {
      if (!errorDetail) {
        console.error('No hay datos para descargar');
        return;
      }
    
      const rows = errorDetail.split(',');
      const csvContent = rows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'errores.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }




  }
}
